//footer mobile accordian 
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 575) {
    const headings = document.querySelectorAll('.footer-block__heading');

    // Close all first
    headings.forEach((heading, index) => {
      const content = heading.nextElementSibling;
      if (content) {
        content.style.display = "none";
        heading.parentElement.classList.remove('open');
      }
    });

    // Open only the first one
    if (headings.length > 0) {
      const firstContent = headings[0].nextElementSibling;
      if (firstContent) {
        firstContent.style.display = "block";
        headings[0].parentElement.classList.add('open');
      }
    }

    // Click functionality (only one open at a time)
    headings.forEach(function (heading) {
      heading.addEventListener('click', function () {
        const currentContent = this.nextElementSibling;

        // Close all others
        headings.forEach(h => {
          const content = h.nextElementSibling;
          if (content && content !== currentContent) {
            content.style.display = "none";
            h.parentElement.classList.remove('open');
          }
        });

        // Toggle current
        if (currentContent) {
          const isOpen = currentContent.style.display === "block";
          currentContent.style.display = isOpen ? "none" : "block";
          this.parentElement.classList.toggle('open', !isOpen);
        }
      });
    });
  }
});